function generateIdFromProducto(producto) {
    return `${producto.nombre}-${producto.categoria}`
      .toLowerCase()
      .replace(/\s+/g, '-')       
      .replace(/[^a-z0-9-]/g, ''); 
  }
  function limpiarTextoParaSlug(texto) {
    return texto
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") 
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-') 
      .replace(/[^a-z0-9-]/g, ''); 
  }

const telasPremiumVeritlux = [
    {
        nombre: "Madeira",
        categoria: "Telas Premium",
        colores: ["Ivory", "Cool Grey", "Beige", "Wood"],
        images: [
            require("../../assets/img/productos/vertilux/vertiluxMadeira/muestra.jpg"),
            require("../../assets/img/productos/vertilux/vertiluxMadeira/2.jpg"),
            require("../../assets/img/productos/vertilux/vertiluxMadeira/3.jpg"),
            require("../../assets/img/productos/vertilux/vertiluxMadeira/4.jpg"),
            require("../../assets/img/productos/vertilux/vertiluxMadeira/5.jpg")
        ],
        composicion: "77% Poliéster + 23% Algodón",
        peso: "160 gr/m² ± 5% | 4.72 oz/yd² ± 5%",
        grosor: "0.65 mm ± 5% | 0.026 in ± 5%",
        tamanoFranja: "Sólido: 110 mm ± 1% | 4 1/3 ± 1%",
        Malla:"70 mm ± 1% | 2 3/4 ± 1% ",
        anchoRollo: "2.8 m | 110.2 in",
        largoRollo: "50 m | 54.68 yd",
        resistenciaTension: "Largo: 225 N | Ancho: 1048.1 N",
        elongacion: "Largo: 40.4% | Ancho: 16.8%",
        resistenciaLuz: "Por encima de 4.5 Grado Xenotest",
        propiedadesControlSolar: [
          'bloqueoUVR: "98.2%"',
          'bloqueoUVA: "97.7%"',
          'bloqueoUVB: "99.4%"',
          'transmisionTS: "16.8%"',
          'reflexionRS: "46.9%"',
          'absorcionAS: "36.2%"'
        ],
        cuidado: [
          "Aspirado para mantenimiento regular.",
          "No lavar.",
          "No exprimir.",
          "No usar blanqueador.",
          "No lavar en seco o con sistemas de vapor."
        ],
        manufactura: "Fabricación en el sentido del rollo.",
        certificaciones: [
          "Libre de PBBs",
          "Libre de PBDEs",
          "Libre de Plomo",
          "Libre de Cadmio",
          "Libre de Mercurio",
          "Libre de Cromo"
        ],
        aplicaciones: [
          "Persianas Duales",
          "Únicamente para uso interior"
        ]
      },
      {
        nombre: "Arcadia",
        categoria: "Telas Premium",
        colores: ["Cream", "White", "Anthracite"],
        images: [
            require("../../assets/img/productos/vertilux/vertiluxArcadia/muestra.jpg"),
            require("../../assets/img/productos/vertilux/vertiluxArcadia/2.jpg"),
            require("../../assets/img/productos/vertilux/vertiluxArcadia/3.jpg"),
            require("../../assets/img/productos/vertilux/vertiluxArcadia/4.jpg")
        ],
        composicion: "100% Poliéster",
        peso: "140 g/m² ± 5% | 4.13 oz/yd² ± 5%",
        grosor: "0.60 mm ± 5% | 0.024 in ± 5%",
        tamanoFranja: "Sólido: 118 mm ± 1% | 4 % in ± 1%",
        Malla: "78 mm ± 1% | 3 % in ± 1%",
        anchoRollo: "2.8 m | 110.2 in",
        largoRollo: "50 m | 54.68 yd",
        resistenciaTension: "Largo: 140 N/5cm | Ancho: 3900 N/5cm",
        resistenciaRasgado: "Largo: 1.8 N | Ancho: 2.9 N",
        resistenciaLuz: "4.5 Grado Xenotest",
        propiedadesControlSolar: [
          'bloqueoUVR: "89.4%"',
          'bloqueoUVA: "86.1%"',
          'bloqueoUVB: "97.2%"',
          'transmisionTS: "30.2%"',
          'reflexionRS: "67.9%"',
          'absorcionAS: "1.9%"'
        ],
        cuidado: [
          "Aspirado para mantenimiento regular.",
          "No lavar.",
          "No exprimir.",
          "No usar blanqueador.",
          "No lavar en seco o con sistemas de vapor."
        ],
        manufactura: "Fabricación en el sentido del rollo.",
        certificaciones: [
          "Libre de PBBs",
          "Libre de PBDEs",
          "Libre de Plomo",
          "Libre de Cadmio",
          "Libre de Mercurio",
          "Libre de Cromo"
        ],
        aplicaciones: [
          "Persianas Duales",
          "Únicamente para uso interior"
        ]
      },
      {
        nombre: "Horizon",
        categoria: "Telas Premium",
        colores: ["White", "Ivory", "Beige", "Wood"],
        images: [
            require("../../assets/img/productos/vertilux/vertiluxHorizon/muestra.jpg"),
            require("../../assets/img/productos/vertilux/vertiluxHorizon/2.jpg"),
            require("../../assets/img/productos/vertilux/vertiluxHorizon/3.jpg"),
            require("../../assets/img/productos/vertilux/vertiluxHorizon/4.jpg"),
            require("../../assets/img/productos/vertilux/vertiluxHorizon/5.jpg")
        ],
        composicion: "100% Poliéster",
        peso: "142 g/m² ± 5% | 4.19 oz/yd² ± 5%",
        grosor: "0.50 mm ± 5% | 0.020 in ± 5%",
        tamanoFranja: "Sólido: 85 mm ± 1% | 3 3/8 in ± 1%",
        Malla: "55 mm ± 1% | 2 1/8 in ± 1%",
        anchoRollo: "2.8 m | 110.2 in",
        largoRollo: "50 m | 54.68 yd",
        resistenciaTension: "Largo: 209.5 daN | Ancho: 25.2 daN",
        elongacion: "Largo: 23.1% | Ancho: 11.1%",
        resistenciaLuz: "Por encima de 4.5 Grado Xenotest",
        propiedadesControlSolar: [
          'UPF: "30"',
          'UV-A: "13.8%"',
          'UV-B: "2.0%"',
          'bloqueoUVR: "89.2%"',
          'bloqueoUVA: "86.2%"',
          'bloqueoUVB: "98.0%"',
          'transmisionTS: "34.1%"',
          'reflexionRS: "58.1%"',
          'absorcionAS: "7.8%"'
        ],
        cuidado: [
          "Aspirado para mantenimiento regular.",
          "No lavar.",
          "No exprimir.",
          "No usar blanqueador.",
          "No lavar en seco o con sistemas de vapor."
        ],
        manufactura: "Fabricación en el sentido del rollo.",
        certificaciones: [
          "Libre de PBBs",
          "Libre de PBDEs",
          "Libre de Plomo",
          "Libre de Cadmio",
          "Libre de Mercurio",
          "Libre de Cromo"
        ],
        aplicaciones: [
          "Persianas Duales",
          "Únicamente para uso interior"
        ]
      }
    ].map(producto => ({
        ...producto,
        id: generateIdFromProducto(producto),
        slug: limpiarTextoParaSlug(`${producto.nombre}-${producto.categoria}`),
        categoriaSlug: limpiarTextoParaSlug(producto.categoria)
      }));
    export default telasPremiumVeritlux;